import React from "react";
import PropTypes from "prop-types";

export default function GoogleAds(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
    >
      <path
        d="M0.825439 26.6731L14.1259 3.6344L25.6509 10.2887L12.3521 33.3274L0.825439 26.6731Z"
        fill="#FBBC04"
      />
      <path
        d="M39.0627 26.5927L25.7541 3.54585C24.0361 0.29649 20.0104 -0.944948 16.7611 0.773083C13.5117 2.49112 12.2719 6.51678 13.9883 9.76613C14.0636 9.90862 14.1439 10.0478 14.2291 10.1854L27.5377 33.2323C29.3327 36.439 33.3878 37.5838 36.5946 35.7888C39.8014 33.9938 40.9462 29.9387 39.1512 26.7319C39.1217 26.6795 39.0922 26.6287 39.0627 26.578V26.5927Z"
        fill="#4285F4"
      />
      <path
        d="M6.6543 36.6028C10.3294 36.6028 13.3086 33.6236 13.3086 29.9485C13.3086 26.2734 10.3294 23.2942 6.6543 23.2942C2.97923 23.2942 0 26.2734 0 29.9485C0 33.6236 2.97923 36.6028 6.6543 36.6028Z"
        fill="#34A853"
      />
    </svg>
  );
}

GoogleAds.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

GoogleAds.defaultProps = {
  className: "",
  width: 40,
  height: 40
};
